/**
 * Processing Overlay Store
 *
 * Backs the app-wide blocking "processing" spinner (incident creation,
 * safezone updates, marker moves, etc.). The overlay is rendered once in
 * App.vue — outside the `<router-view :key="$route.fullPath">` — so it is not
 * tied to any routed view's lifecycle.
 *
 * Owning visibility here (rather than inside a routed view such as MapLayout)
 * prevents the modal from being orphaned in the DOM when an in-flight async
 * flow triggers navigation while the overlay is open: the keyed router-view
 * would otherwise unmount the owning component mid-open, stranding PrimeVue's
 * teleported mask on screen forever.
 */
import { defineStore } from "pinia";
import { ref } from "vue";

export const useProcessingOverlayStore = defineStore("processingOverlay", () => {
    const visible = ref(false);
    const message = ref("Processing...");

    /** Show the overlay with an optional status message. */
    const show = (text = "Processing...") => {
        message.value = text;
        visible.value = true;
    };

    /** Hide the overlay. */
    const hide = () => {
        visible.value = false;
    };

    return { visible, message, show, hide };
});
